import { QueryClientProvider } from '@tanstack/react-query';
// import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import React from 'react';

import { queryClient } from '@doger/core/shared/api/cache';

type QueryProviderProps = {
  children: React.ReactNode;
};

export const QueryProvider = ({ children }: QueryProviderProps) => (
  <QueryClientProvider client={queryClient}>
    {children}

    {/* {import.meta.env.DEV && <ReactQueryDevtools initialIsOpen={false} />} */}
  </QueryClientProvider>
);
